import Login from '@/components/authentication/Login'
import Dashboard from '@/components/dashboard/Dashboard'
import Orders from '@/components/orders/Orders'
import OrdersToday from '@/components/orders/OrdersToday'
import OrdersScheduled from '@/components/orders/OrdersScheduled'
import OrdersSaved from '@/components/orders/OrdersSaved'
import OrdersAll from '@/components/orders/OrdersAll'
import Customers from '@/components/customers/Customers'
import CustomerGroups from '@/components/customers/CustomerGroups'
import DeliveryStaff from '@/components/delivery/DeliveryStaff'
import DeliveryUserDashboard from '@/components/delivery/user/DeliveryUserDashboard'
import WaiterStaff from '@/components/waiters/WaiterStaff'
import Staff from '@/components/staff/Staff'
import StaffGroups from '@/components/staff/StaffGroups'
import Pos from '@/components/pos/Pos'
import Tags from '@/components/restaurant/kitchen/Tags'
import KitchenMenu from '@/components/restaurant/kitchen/Menu'
import KitchenCatalogs from '@/components/restaurant/kitchen/Catalogs'
import KitchenMenuCategories from '@/components/restaurant/kitchen/Categories'
import KitchenMealTimes from '@/components/restaurant/kitchen/MealTimes'
import KitchenMenuOptions from '@/components/restaurant/kitchen/Options'
import KitchenMenuOptionValueGroups from '@/components/restaurant/kitchen/MenuOptionValueGroups'
import MarketingCoupons from '@/components/marketing/coupon/Coupons'
import MarketingTag from '@/components/marketing/tag/Tags'
import MarketingEmail from '@/components/marketing/email/Email'
import MarketingSms from '@/components/marketing/sms/Sms'
import MarketingPush from '@/components/marketing/push/Push'
import MarketingPrint from '@/components/marketing/print/Print'
import MessagesInbox from '@/components/messages/MessagesInbox'
import SystemSettings from '@/components/settings/SystemSettings'
import SystemSettingsRestaurant from '@/components/settings/SystemSettingsRestaurant'
import SystemSettingsWorkingHours from '@/components/settings/SystemSettingsWorkingHours'
import SystemSettingsOrders from '@/components/settings/SystemSettingsOrders'
import SystemSettingsReservations from '@/components/settings/SystemSettingsReservations'
import SystemSettingsNotifications from '@/components/settings/SystemSettingsNotifications'
import SystemSettingsPrinters from '@/components/settings/SystemSettingsPrinters'
import SystemSettingsDisplays from '@/components/settings/SystemSettingsDisplays'
import SystemSettingsDelivery from '@/components/settings/SystemSettingsDelivery'
import SystemSettingsEmail from '@/components/settings/SystemSettingsEmail'
import SystemSettingsTables from '@/components/settings/SystemSettingsTables'
import SystemSettingsPinManager from '@/components/settings/SystemSettingsPinManager'
import SystemSettingsPayments from '@/components/settings/SystemSettingsPayments'
import SystemSettingsWebSite from '@/components/settings/SystemSettingsWebSite'
import SystemSettingsRegional from '@/components/settings/SystemSettingsRegional'
import SystemSettingsDocuments from '@/components/settings/SystemSettingsDocuments'
import SystemSettingsPermissions from '@/components/settings/SystemSettingsPermissions'
import SystemSettingsDomains from '@/components/settings/SystemSettingsDomains'
import SystemSettingsVoipDomains from '@/components/settings/SystemSettingsVoipDomains'
import SystemSettingsOnlineUsers from '@/components/settings/SystemSettingsOnlineUsers'
import SystemSettingsSystemUsers from '@/components/settings/SystemSettingsSystemUsers'
import SystemSettingsKds from '@/components/settings/SystemSettingsKds'
import Faqs from '@/components/faq/Faqs'
import FaqCategories from '@/components/faq/FaqCategories'
import VoipCallHistory from '@/components/voip/VoipCallHistory'
import Account from '@/components/account/Account'
import AccountOverview from '@/components/account/AccountOverview'
import AccountBilling from '@/components/account/AccountBilling'
import AccountPlans from '@/components/account/AccountPlans'
import AccountInvoices from '@/components/account/AccountInvoices'
import SupportCenter from '@/components/support-center/SupportCenter'
import TableFloorPlan from '@/components/restaurant/tables/floor-plan/TableFloorPlan'
import TableAreasManagement from '@/components/restaurant/tables/management/TableAreasManagement'
import TableManagement from '@/components/restaurant/tables/management/TableManagement'
import Tables from '@/components/restaurant/tables/tables/Tables'
import QrManagement from '@/components/qr/QrManagement'
import Charges from '@/components/charges/Charges'
import Statistics from '@/components/statistics/Statistics'
import ProductStatistics from '@/components/statistics/ProductStatistics'
import OrdersHeatmap from '@/components/statistics/OrdersHeatmap'
import SalesReportZ from '@/components/reports/SalesReportZ.vue'
import Reports from '@/components/reports/Reports.vue'
import ReportsNotify from '@/components/reports/ReportsNotify.vue'
import TableReservation from '@/components/restaurant/reservations/TableReservation'
import Receipts from '@/components/receipts/Receipts'
import EftPosTransactions from '@/components/payments/EftPosTransactions'
import Kds from '@/components/kds/Kds'
import Cds from '@/components/cds/Cds'
import DomainLocked from '@/components/account/DomainLocked'
import ActivityLog from '@/components/activity-log/ActivityLog'
import Pages from '@/components/pages/Pages.vue'
import PageContent from '@/components/pages/PageContent.vue'

const routerComponents = {
  Login                       : Login,
  Dashboard                   : Dashboard,
  Orders                      : Orders,
  OrdersToday                 : OrdersToday,
  OrdersScheduled             : OrdersScheduled,
  OrdersSaved                 : OrdersSaved,
  OrdersAll                   : OrdersAll,
  Customers                   : Customers,
  CustomerGroups              : CustomerGroups,
  DeliveryStaff               : DeliveryStaff,
  DeliveryUserDashboard       : DeliveryUserDashboard,
  WaiterStaff                 : WaiterStaff,
  Staff                       : Staff,
  StaffGroups                 : StaffGroups,
  Pos                         : Pos,
  Tags                        : Tags,
  KitchenMenu                 : KitchenMenu,
  KitchenCatalogs             : KitchenCatalogs,
  KitchenMealTimes            : KitchenMealTimes,
  KitchenMenuCategories       : KitchenMenuCategories,
  KitchenMenuOptions          : KitchenMenuOptions,
  KitchenMenuOptionValueGroups: KitchenMenuOptionValueGroups,
  MarketingCoupons            : MarketingCoupons,
  MarketingTag                : MarketingTag,
  MarketingEmail              : MarketingEmail,
  MarketingSms                : MarketingSms,
  MarketingPush               : MarketingPush,
  MarketingPrint              : MarketingPrint,
  MessagesInbox               : MessagesInbox,
  SystemSettings              : SystemSettings,
  SystemSettingsRestaurant    : SystemSettingsRestaurant,
  SystemSettingsWorkingHours  : SystemSettingsWorkingHours,
  SystemSettingsDelivery      : SystemSettingsDelivery,
  SystemSettingsEmail         : SystemSettingsEmail,
  SystemSettingsTables        : SystemSettingsTables,
  SystemSettingsPinManager    : SystemSettingsPinManager,
  SystemSettingsPayments      : SystemSettingsPayments,
  SystemSettingsWebSite       : SystemSettingsWebSite,
  SystemSettingsRegional      : SystemSettingsRegional,
  SystemSettingsDocuments     : SystemSettingsDocuments,
  SystemSettingsOrders        : SystemSettingsOrders,
  SystemSettingsReservations  : SystemSettingsReservations,
  SystemSettingsNotifications : SystemSettingsNotifications,
  SystemSettingsPrinters      : SystemSettingsPrinters,
  SystemSettingsDisplays      : SystemSettingsDisplays,
  SystemSettingsPermissions   : SystemSettingsPermissions,
  SystemSettingsDomains       : SystemSettingsDomains,
  SystemSettingsVoipDomains   : SystemSettingsVoipDomains,
  SystemSettingsOnlineUsers   : SystemSettingsOnlineUsers,
  SystemSettingsSystemUsers   : SystemSettingsSystemUsers,
  SystemSettingsKds           : SystemSettingsKds,
  Faqs                        : Faqs,
  FaqCategories               : FaqCategories,
  VoipCallHistory             : VoipCallHistory,
  Account                     : Account,
  AccountOverview             : AccountOverview,
  AccountBilling              : AccountBilling,
  AccountPlans                : AccountPlans,
  AccountInvoices             : AccountInvoices,
  SupportCenter               : SupportCenter,
  TableAreasManagement        : TableAreasManagement,
  TableManagement             : TableManagement,
  Tables                      : Tables,
  TableFloorPlan              : TableFloorPlan,
  QrManagement                : QrManagement,
  Charges                     : Charges,
  Statistics                  : Statistics,
  ProductStatistics           : ProductStatistics,
  OrdersHeatmap               : OrdersHeatmap,
  TableReservation            : TableReservation,
  Receipts                    : Receipts,
  EftPosTransactions          : EftPosTransactions,
  Cds                         : Cds,
  Kds                         : Kds,
  DomainLocked                : DomainLocked,
  ActivityLog                 : ActivityLog,
  Reports                     : Reports,
  ReportsNotify               : ReportsNotify,
  SalesReportZ                : SalesReportZ,
  Pages                       : Pages,
  PageContent                 : PageContent
}

const routes = [
  {
    name     : 'Login',
    path     : '/login',
    component: Login,
    meta     : {
      requiresAuth: false,
      layout      : 'login'
    }
  },
  {
    name     : 'Cds',
    path     : '/cds',
    component: Cds,
    meta     : {
      requiresAuth: false,
      layout      : 'empty'
    }
  },
  {
    name     : 'DomainLocked',
    path     : '/locked',
    component: DomainLocked,
    meta     : {
      requiresAuth: false,
      layout      : 'locked'
    }
  },
  /*
  {
    name     : 'Pages',
    path     : '/page',
    component: Pages,
    redirect : {name: 'PoliciesTerms'},
    meta     : {
      requiresAuth: false
    },
    children: [
      {
        name     : 'PoliciesTerms',
        path     : 'policies/terms',
        component: PageContent,
        meta     : {
          group       : 'policies',
          layout      : 'page',
          requiresAuth: false
        }
      }
    ]
  },
   */
  /*
  {
    name     : 'TableFloorPlan',
    path     : '/table-management/floor-plan',
    component: TableFloorPlan,
    meta     : {
      title       : 'FLOOR PLAN',
      subTitle    : 'Διαχείριση Τραπεζιών',
      requiresAuth: true
    }
  },
   */
  {
    name    : 'Default',
    path    : '*',
    redirect: '/login'
  }
]

window.routerComponents = routerComponents

export default routes
